import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  Divider
} from '@mui/material';
import {
  Cancel,
  ArrowBack,
  ShoppingCart
} from '@mui/icons-material';

const PaymentCancelScreen: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const bookingId = searchParams.get('booking');

  return (
    <Box maxWidth="600px" mx="auto" p={3}>
      {/* En-tête d'annulation */}
      <Box textAlign="center" mb={4}>
        <Cancel sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom color="warning.main">
          Paiement Annulé
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Votre paiement a été annulé
        </Typography>
      </Box>

      {/* Carte d'information */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body1">
              Vous avez annulé le processus de paiement. Aucun montant n'a été débité de votre compte.
            </Typography>
          </Alert>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" paragraph>
            Si vous souhaitez finaliser votre réservation, vous pouvez :
          </Typography>

          <Box component="ul" sx={{ pl: 2 }}>
            <li>
              <Typography variant="body2">
                Réessayer le paiement avec une autre carte
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Vérifier que votre carte est valide et dispose de fonds suffisants
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Contacter le support si le problème persiste
              </Typography>
            </li>
          </Box>

          {bookingId && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="body2" color="text.secondary">
                ID de réservation : {bookingId}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>

      {/* Actions */}
      <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
        <Button 
          variant="contained" 
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{ backgroundColor: '#a5816d', '&:hover': { backgroundColor: '#8B7355' } }}
        >
          Réessayer le paiement
        </Button>
        <Button 
          variant="outlined" 
          startIcon={<ShoppingCart />}
          onClick={() => navigate('/')}
        >
          Continuer mes achats
        </Button>
      </Box>

      {/* Informations de contact */}
      <Box mt={4} textAlign="center">
        <Typography variant="body2" color="text.secondary">
          Besoin d'aide ? Contactez notre support client
        </Typography>
        <Typography variant="body2" color="primary">
          support@allure.com
        </Typography>
      </Box>
    </Box>
  );
};

export default PaymentCancelScreen;
